import { Route, Routes } from 'react-router';
import { selectUsers } from './Components/store/usersSlice';
import { useSelector } from 'react-redux';
import { ThemeProvider } from './ThemeContext';

// Components
import NavBar from './Components/Navbar/NavBar';
import MainPage from './Components/MainPage/MainPage';
import Home from './Components/Home/Home';
import { LoginPage } from './Components/LoginPage/LoginPage';
import AddedLists from './Components/AddedLists/AddedLists';
import LoadingScreen from './Components/Loading/LoadingScreen';
import About from './Components/About/About';
import Footer from './Components/Footer/Footer';
import Settings from './Components/Settings/Settings';
import PersonalSettings from './Components/PersonalSettings/PersonalSettings';
import AccountSettings from './Components/AccountSettings/AccountSettings';
import ThemeSync from './Components/ThemeSync/ThemeSync';

function App() {
  const user = useSelector(selectUsers);

  if (user.loading) {
    return <LoadingScreen />
  }

  return (
    <ThemeProvider>
      <ThemeSync />
      {user.currentUser ? 
        <div>
          <NavBar/>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/list/:listId" element={<MainPage />} />
            <Route path="/addedlists" element={<AddedLists />} />
            <Route path="/about" element={ <About /> } />
            <Route path="/settings" element={ <Settings /> } />
            <Route path="/settings/personalinformation" element={ <PersonalSettings />} />
            <Route path="/settings/accountsettings" element={ <AccountSettings />} />
          </Routes>
          <Footer user={user}/>
        </div>
        :
        <LoginPage />
      } 
    </ThemeProvider>
  )
}

export default App;
